const data = 
[
    {
        "brand": "索尼",
        "camera": "RX100 Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "RX100 Ⅳ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.30",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "RX100 VA",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "RX100 Ⅵ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "RX100 Ⅶ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "ZV-1",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "DSC-WX500",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "DSC-HX90",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "DSC-RX10 Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "DSC-RX10 IV",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "ZV-E10",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、将相机中“使用智能手机控制” 功能关闭：\n网络-使用智能手机控制-关闭\n2、将相机的“USB 连接”功能设置为“电脑遥控”：\n网络-电脑遥控功能-电脑遥控-开\n3、静态影像保存目的地选“仅拍摄装置”：\n网络-电脑遥控功能-静态影像保存目的地-仅拍摄装置\n4、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\"\n5、连接好后，稳定器先开机，相机再开机\n6、成功连接后稳定器屏幕的相机图标亮起，相机的屏幕显示“PC”。 \n7、相机处于拍照模式时，云台可切换控制拍照、录像；相机处于录像模式时，云台只能控制录像\""
    },
    {
        "brand": "索尼",
        "camera": "A6100",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A6300",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A6400",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A6500",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A6600",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7S",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.20",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7S Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7R",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7R Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7R Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.01",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7R Ⅳ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7R Ⅳ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1.将相机中“使用智能手机控制” 功能关闭。具体设置方法如下： 选择：菜单--网络--使用智能手机控制--选择关闭。\n2.将相机的“USB 连接”功能设置为“电脑遥控”。具体设置方法如下：网络--传输/远程--电脑遥控功能--开。\n3.使用电控跟焦功能，需将镜头设置为AF模式，相机设置为AF模式。\n4.使用 USB 快门线连接相机和云台时，相机有可能无法使用回放，此时电脑遥控中镜头影像保存目的地不能设置成：仅电脑\n5.使用拍照功能时，避免拍照丢张照片的设置方法：网络--传输/远程--电脑遥控功能--静态影像保存目的地--仅拍摄装置。"
    },
    {
        "brand": "索尼",
        "camera": "A7R IVA",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7 Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7 Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": 3.1,
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A9",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "6.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A9 Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A7C",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、将相机中“使用智能手机控制” 功能关闭。步骤：\n网络-使用智能手机控制-关闭\n2、将相机的“USB 连接”功能设置为“电脑遥控”。步骤：\n网络-电脑遥控功能-电脑遥控-开\n3、静态影像保存目的地选（仅拍摄装置）。步骤：\n网络-电脑遥控功能-静态影像保存目的地-仅拍摄装置\n4、连接好后，稳定器先开机，相机再开机\n5、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\""
    },
    {
        "brand": "索尼",
        "camera": "A1",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\"\n4、将相机中“使用智能手机控制” 功能关闭\n步骤：网络-使用智能手机控制-关闭"
    },
    {
        "brand": "索尼",
        "camera": "A7S Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n3、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\"\n4、将相机中“使用智能手机控制” 功能关闭\n步骤：网络-使用智能手机控制-关闭"
    },
    {
        "brand": "索尼",
        "camera": "A7S Ⅲ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、将相机中“使用智能手机控制” 功能关闭：\n网络-使用智能手机控制-关闭\n2、将相机的“USB 连接”功能设置为“电脑遥控”：\n网络-电脑遥控功能-电脑遥控-开\n3、静态影像保存目的地选（仅拍摄装置）：\n网络-电脑遥控功能-静态影像保存目的地-仅拍摄装置\n4、成功连接后稳定器屏幕的相机图标亮起。相机的屏幕显示“PC”\n5、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\"   \n6、如需换用其他控制线，相机和稳定器都需要重启。"
    },
    {
        "brand": "索尼",
        "camera": "FX3",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、将相机中“使用智能手机控制” 功能关闭：\n网络-使用智能手机控制-关闭\n2、连接好控制线后，需要先打开稳定器再打开相机。\n3、成功连接后稳定器屏幕的相机图标亮起\n4、控制数码变焦时，需将\"变焦设置\"为\"数字变焦\"或\"清晰影像缩放\"\n5、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\"\n6、如需换用其他控制线，相机和稳定器都需要重启。"
    },
    {
        "brand": "索尼",
        "camera": "FX3",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、将相机中“使用智能手机控制” 功能关闭：\n网络-使用智能手机控制-关闭\n2、将相机的“USB 连接”功能设置为“电脑遥控”：\n网络-电脑遥控功能-电脑遥控-开\n3、静态影像保存目的地选（仅拍摄装置）：\n网络-电脑遥控功能-静态影像保存目的地-仅拍摄装置\n4、成功连接后稳定器屏幕的相机图标亮起。相机的屏幕显示“PC”\n5、拍摄全景和延时摄影时，相机\"自动检视\"设置为\"关\"   \n6、如需换用其他控制线，相机和稳定器都需要重启。"
    },
    {
        "brand": "索尼",
        "camera": "A7 IV",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、连接好控制线后，稳定器先开机，相机再开机\n2、控制相机的数码变焦功能，需打开相机的数码变焦功能"
    },
    {
        "brand": "索尼",
        "camera": "A7 IV",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V106",
        "note": "1.将相机中“使用智能手机控制” 功能关闭。具体设置方法如下： 选择：菜单--网络--使用智能手机控制--选择关闭。\n2.将相机的“USB 连接”功能设置为“电脑遥控”。具体设置方法如下：第一步，在相机上设置电脑遥控。具体设置方法如下：MENU——网络——传输/远程——电脑遥控功能——电脑遥控——开\n3.在使用电控跟焦功能的时候，请将镜头设置为 AF 模式，机身设置为 MF 模式，否则无法使用电控跟焦功能。\n4.使用 USB 快门线连接相机和云台时，相机有可能无法使用回放，此时电脑遥控中镜头影像保存目的地不能设置成：仅电脑\n5.使用拍照功能时，避免拍照丢张照片的设置方法：网络--传输/远程--电脑遥控功能--静态影像保存目的地--仅拍摄装置。\n控制快门时，需要将：拍摄-快门/静音-防闪烁设置-可变快门设置为“关”"
    },
    {
        "brand": "索尼",
        "camera": "FDR-AX60",
        "controlLine": "Type-C to Multi",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V106",
        "note": "1.将相机中“使用智能手机控制” 功能关闭。具体设置方法如下： 选择：菜单--网络--使用智能手机控制--选择关闭。\n2.将相机的“USB 连接”功能设置为“电脑遥控”。具体设置方法如下：第一步，在相机上设置电脑遥控。具体设置方法如下：MENU——网络——传输/远程——电脑遥控功能——电脑遥控——开\n3.在使用电控跟焦功能的时候，请将镜头设置为 AF 模式，机身设置为 MF 模式，否则无法使用电控跟焦功能。\n4.使用 USB 快门线连接相机和云台时，相机有可能无法使用回放，此时电脑遥控中镜头影像保存目的地不能设置成：仅电脑\n5.使用拍照功能时，避免拍照丢张照片的设置方法：网络--传输/远程--电脑遥控功能--静态影像保存目的地--仅拍摄装置。\n控制快门时，需要将：拍摄-快门/静音-防闪烁设置-可变快门设置为“关”"
    },
    {
        "brand": "索尼",
        "camera": "FDR-AX700",
        "controlLine": "Type-C to Multi",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V120",
        "note": "1.将相机中“使用智能手机控制” 功能关闭。具体设置方法如下： 选择：菜单--网络--使用智能手机控制--选择关闭。\n2.将相机的“USB 连接”功能设置为“电脑遥控”。具体设置方法如下：第一步，在相机上设置电脑遥控。具体设置方法如下：MENU——网络——传输/远程——电脑遥控功能——电脑遥控——开\n3.在使用电控跟焦功能的时候，请将镜头设置为 AF 模式，机身设置为 MF 模式，否则无法使用电控跟焦功能。\n4.使用 USB 快门线连接相机和云台时，相机有可能无法使用回放，此时电脑遥控中镜头影像保存目的地不能设置成：仅电脑\n5.使用拍照功能时，避免拍照丢张照片的设置方法：网络--传输/远程--电脑遥控功能--静态影像保存目的地--仅拍摄装置。\n控制快门时，需要将：拍摄-快门/静音-防闪烁设置-可变快门设置为“关”"
    },
    {
        "brand": "佳能",
        "camera": "EOS M50",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"；"
    },
    {
        "brand": "佳能",
        "camera": "EOS M50 Mark Ⅱ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"；"
    },
    {
        "brand": "佳能",
        "camera": "EOS M6 Mark Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"；"
    },
    {
        "brand": "佳能",
        "camera": "Powershot G7 X Mark Ⅲ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"\n4、需要关闭WIFI，再连接"
    },
    {
        "brand": "佳能",
        "camera": "EOS 200D Ⅱ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"\n4、EOS 200D Ⅱ相机在需要在拍照模式下开机，否则相机屏幕可能会没有显示"
    },
    {
        "brand": "佳能",
        "camera": "EOS 850D",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\""
    },
    {
        "brand": "佳能",
        "camera": "EOS 80D",
        "controlLine": "Type-C to Mini\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.2",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\""
    },
    {
        "brand": "佳能",
        "camera": "EOS 90D",
        "controlLine": "Type-C to micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V106",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"\n4、EOS 90D相机在需要在拍照模式下开机，否则相机屏幕可能会没有显示"
    },
    {
        "brand": "佳能",
        "camera": "EOS 6D",
        "controlLine": "Type-C to Mini\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.8",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\""
    },
    {
        "brand": "佳能",
        "camera": "EOS 6D Mark Ⅱ",
        "controlLine": "Type-C to Mini\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\""
    },
    {
        "brand": "佳能",
        "camera": "EOS 5D Mark Ⅲ",
        "controlLine": "Type-C to Mini\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.3.5",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\""
    },
    {
        "brand": "佳能",
        "camera": "EOS 5D Mark Ⅳ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.2",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\""
    },
    {
        "brand": "佳能",
        "camera": "EOS 5DS R",
        "controlLine": "Type-c to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。\n2、使用电子跟焦时，尝试将镜头拨到MF和AF档以选取最佳控制效果；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\""
    },
    {
        "brand": "佳能",
        "camera": "EOS RP",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.6.0",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、在拍照模式下不能使用快门线控制录像，否则相机容易出现死机；\n4、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"；\n5、经测试发现，使用转接环配EF卡口镜头会增加电子跟焦延时；\n6、若外接HDMI，需要把拍摄(相机)设置页中的HDMI显示选项设置为相机+HDMI 才能控制拍照/录像"
    },
    {
        "brand": "佳能",
        "camera": "EOS R",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"；\n4、经测试发现，使用转接环配EF卡口镜头会增加电子跟焦延时；\n5、若外接HDMI，需要把拍摄(相机)设置页中的HDMI显示选项设置为相机+HDMI 才能控制拍照/录像"
    },
    {
        "brand": "佳能",
        "camera": "EOS R5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.9.0",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、在拍照模式下不能使用快门线控制录像，否则相机容易出现死机；\n4、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"；\n5、经测试发现，使用转接环配EF卡口镜头会增加电子跟焦延时；\n6、若外接HDMI，需要把拍摄(相机)设置页中的HDMI显示选项设置为相机+HDMI 才能控制拍照/录像"
    },
    {
        "brand": "佳能",
        "camera": "EOS R6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；\n2、使用电子跟焦时，需要将镜头上拨到MF档；\n3、在拍照模式下不能使用快门线控制录像，否则相机容易出现死机；\n4、拍摄延时摄影时，佳能相机\"图像确认\"设置为\"关\"；\n5、经测试发现，使用转接环配EF卡口镜头会增加电子跟焦延时；\n6、若外接HDMI，需要把拍摄(相机)设置页中的HDMI显示选项设置为相机+HDMI 才能控制拍照/录像"
    },
    {
        "brand": "佳能",
        "camera": "EOS R5C",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0.1",
        "gimbalFirmware": "Gimbal_V1.06",
        "note": "1、云台、相机均开机后，需要等待约10秒钟才能建立连接\n2、相机处于photo档时，云台可控拍照、录像；\n3、相机处于video档时，云台可控录像\n4、回看图片得切换到photo，回看视频得切换到video"
    },
    {
        "brand": "佳能",
        "camera": "EOS R7",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V1.06",
        "note": "1、云台、相机均开机后，需要等待约10秒钟才能建立连接\n2、相机处于photo档时，云台可控拍照、录像；\n3、相机处于video档时，云台可控录像\n4、回看图片得切换到photo，回看视频得切换到video"
    },
    {
        "brand": "佳能",
        "camera": "EOS R10",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V1.06",
        "note": "1、云台、相机均开机后，需要等待约10秒钟才能建立连接\n2、相机处于photo档时，云台可控拍照、录像；\n3、相机处于video档时，云台可控录像\n4、回看图片得切换到photo，回看视频得切换到video"
    },
    {
        "brand": "佳能",
        "camera": "EOS R8",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V1.20",
        "note": "拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R50",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V1.20",
        "note": "1、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；\n2、使用电子跟焦时，相机设置为MF模式。"
    },
    {
        "brand": "佳能",
        "camera": "EOS R6 Mark Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.2",
        "gimbalFirmware": "Gimbal_V1.20",
        "note": "1、使用电子跟焦时，需要将相机镜头拨到MF档；\n2、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "松下",
        "camera": "GH5S",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 1.2,
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、USB模式选择PC（tether）；\n2、WiFi和USB线控不能同时使用。使用控制线时，需先关掉相机WIFI；                                                                                            \n3、控制拍照时，相机会自动对焦再拍照；\n4、使用电子跟焦功能，需要将相机的对焦模式设置成MF。                              5、相机连接稳定器后，相机在回看相册状态不操作，相机可能会死机。"
    },
    {
        "brand": "松下",
        "camera": "GH5",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2.6,
        "gimbalFirmware": "Gimbal_V105",
        "note": "拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "松下",
        "camera": "GH5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 2.6,
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、USB模式选择PC（tether）；\n2、WiFi和USB线控不能同时使用。使用控制线时，需先关掉相机WIFI；                                                                                            \n3、控制拍照时，相机会自动对焦再拍照；\n4、使用电子跟焦功能，需要将相机的对焦模式设置成MF。                              5、相机连接稳定器后，相机在回看相册状态下不操作，相机可能会死机"
    },
    {
        "brand": "松下",
        "camera": "GH4",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2.7,
        "gimbalFirmware": "Gimbal_V103",
        "note": "拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "松下",
        "camera": "G9",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2,
        "gimbalFirmware": "Gimbal_V103",
        "note": "拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "松下",
        "camera": "S5",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2,
        "gimbalFirmware": "Gimbal_V103",
        "note": "拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "松下",
        "camera": "S5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 2,
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、USB模式选择PC（tether）；\n2、WiFi和USB线控不能同时使用。使用控制线时，需先关掉相机WIFI；                                                                                            \n3、控制拍照时，相机会自动对焦再拍照；\n4、使用电子跟焦功能，需要将相机的对焦模式设置成MF。"
    },
    {
        "brand": "松下",
        "camera": "GH6",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.2,
        "gimbalFirmware": "Gimbal_V106",
        "note": "拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "松下",
        "camera": "GH6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 1.2,
        "gimbalFirmware": "Gimbal_V106",
        "note": "1、USB模式选择PC（tether）；\n2、WiFi和USB线控不能同时使用。使用控制线时，需先关掉相机WIFI；                                                                                            \n3、控制拍照时，相机会自动对焦再拍照；\n4、使用电子跟焦功能，需要将相机的对焦模式设置成MF"
    },
    {
        "brand": "松下",
        "camera": "S5 Ⅱ",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1,
        "gimbalFirmware": "Gimbal_V120",
        "note": "拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "松下",
        "camera": "S5 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 1,
        "gimbalFirmware": "Gimbal_V120",
        "note": "1、USB模式选择PC（tether）；\n2、WiFi和USB线控不能同时使用。使用控制线时，需先关掉相机WIFI；                                                                                            \n3、控制拍照时，相机会自动对焦再拍照；\n4、使用电子跟焦功能，需要将相机的对焦模式设置成MF"
    },
    {
        "brand": "尼康",
        "camera": "Z7",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "×",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "尼康",
        "camera": "Z7 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "尼康",
        "camera": "Z5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.11",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "尼康",
        "camera": "Z6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "尼康",
        "camera": "Z6 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "尼康",
        "camera": "Z50",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "尼康",
        "camera": "Zfc",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "Gimbal_V105",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像                                    3、使用电控跟焦功能时，在录像模式下，需将相机对焦模式设为AF-FS或AF-FC；在拍照模式下，需将对焦模式设为非MF模式。"
    },
    {
        "brand": "尼康",
        "camera": "D7500",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "×",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "Gimbal_V120",
        "note": "1、请确认先连接好快门线，再打开云台，后面打开相机。\n2、开启相机后，需要等待约6秒钟的时间听到“咔嚓”声相机才能成功连接；\n3、用稳定器控制相机，相机实时取景功能需要开启（LV）\n4、相机需在录像模式下开机，Gimbal才能控制相机端录像；另外，开启LV前请确认右上角的小屏幕是否出现“PC”，如已出现，再开启LV模式，最后进行视频拍摄\n5、录像只有灯光显示，相机屏幕不显示时长\n6、与云台连接时，相机按键不可用\n7、控制电子跟焦时，镜头需要在AF模式，且比较慢\n8、云台和相机连接快门线控时，相机不能调出相册"
    },
    {
        "brand": "尼康",
        "camera": "D850",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.2",
        "gimbalFirmware": "Gimbal_V120",
        "note": "1、连接后，稳定器先开机，相机再开机。开启相机后，需要等待约6秒钟的时间听到“哒”声相机才能成功连接；\n2、用稳定器控制相机，相机实时取景功能需要开启（LV）\n3、相机需在录像模式下开机，Gimbal才能控制相机端录像；\n4、回看相册播放视频后得重连才能再次控制，只是预览图片不影响。"
    },
    {
        "brand": "尼康",
        "camera": "Z30",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1、开启相机后，需要等待约6秒钟的时间相机才能成功连接；\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像                                    3、使用焦功能时，在录像模式下，需将相机对焦模式设为AF-S或AF-C；在拍照模式下，需将对焦模式设为非MF模式。"
    },
    {
        "brand": "尼康",
        "camera": "Z8",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V121",
        "note": "由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像"
    },
    {
        "brand": "富士",
        "camera": "X-T20",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.01",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”；\n步骤：进入设置界面，视频设置》麦克风/遥控快门设置》遥控；\n2、需要手动将相机模式切换到录像模式才能通过线控执行录像"
    },
    {
        "brand": "富士",
        "camera": "X-T30",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”；\n步骤：进入设置界面，视频设置》麦克风/遥控快门设置》遥控；\n2、需要手动将相机模式切换到录像模式才能通过线控执行录像"
    },
    {
        "brand": "富士",
        "camera": "X-A5",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V105",
        "note": "需要将“麦克风/遥控快门设置”选择为“遥控”。\n具体步骤：进入设置界面，拍摄设置5》动态影像设置》麦克风/遥控快门设置》遥控"
    },
    {
        "brand": "富士",
        "camera": "X-A7",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "需要将“麦克风/遥控快门设置”选择为“遥控”。\n具体步骤：进入设置界面，拍摄设置5》动态影像设置》麦克风/遥控快门设置》遥控"
    },
    {
        "brand": "富士",
        "camera": "X-T100",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "需要将“麦克风/遥控快门设置”选择为“遥控”。\n具体步骤：进入设置界面，拍摄设置5》动态影像设置》麦克风/遥控快门设置》遥控"
    },
    {
        "brand": "富士",
        "camera": "X-H1",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.01",
        "gimbalFirmware": "Gimbal_V103",
        "note": "需要将“麦克风/遥控快门设置”选择为“遥控”。\n具体步骤：进入设置界面，拍摄设置5》动态影像设置》麦克风/遥控快门设置》遥控"
    },
    {
        "brand": "富士",
        "camera": "X-T3",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "3.01",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、需要接入相机 ø2.5mm遥控快门线接口\n2、需要手动将相机模式切换到录像模式，才能控制录像 \n3、需要手动将相机切换到拍照模式，才能控制拍照"
    },
    {
        "brand": "富士",
        "camera": "X-T4",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、需要接入相机 ø2.5mm遥控快门线接口\n2、需要手动将相机模式切换到录像模式，才能控制录像 \n3、需要手动将相机切换到拍照模式，才能控制拍照"
    },
    {
        "brand": "富士",
        "camera": "X-S10",
        "controlLine": "Type-C to TRS3.5\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.02",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”，\n步骤：进入设置界面，视频设置》麦克风/遥控快门设置》遥控\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像"
    },
    {
        "brand": "富士",
        "camera": "X-T200",
        "controlLine": "Type-C to TRS3.5\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”，\n步骤：进入设置界面，视频设置》麦克风/遥控快门设置》遥控\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像"
    },
    {
        "brand": "富士",
        "camera": "X-E3",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.22",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”，\n步骤：进入设置界面，视频设置》麦克风/遥控快门设置》遥控\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像"
    },
    {
        "brand": "富士",
        "camera": "X-T30 Ⅱ",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V106",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”；\n步骤：进入设置界面，视频设置》麦克风/遥控快门设置》遥控；\n2、需要手动将相机模式切换到录像模式才能通过线控执行录像"
    },
    {
        "brand": "富士",
        "camera": "X100V",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V106",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”。\n具体操作：进入设置界面，视频设置》麦克风/遥控快门设置》遥控\n2、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像。"
    },
    {
        "brand": "富士",
        "camera": "GFX 100S",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.32",
        "gimbalFirmware": "Gimbal_V106",
        "note": "由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像。"
    },
    {
        "brand": "富士",
        "camera": "X-H2S",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V120",
        "note": "由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像。"
    },
    {
        "brand": "富士",
        "camera": "X-H2",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.21,
        "gimbalFirmware": "Gimbal_V120",
        "note": "由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像。"
    },
    {
        "brand": "富士",
        "camera": "X-T5",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.02,
        "gimbalFirmware": "Gimbal_V120",
        "note": "由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像。"
    },
    {
        "brand": "富士",
        "camera": "X-S20",
        "controlLine": "Type-C to TRS3.5\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.11,
        "gimbalFirmware": "Gimbal_V121",
        "note": "1、需要将“麦克风/遥控快门设置”选择为“遥控”；\n步骤：进入设置界面，视频设置》麦克风/遥控快门设置》遥控；\n2、需要手动将相机模式切换到录像模式才能通过线控执行录像"
    },
    {
        "brand": "SIGMA",
        "camera": "FP",
        "controlLine": "Type-C to Type-C",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "×",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "Gimbal_V106",
        "note": "1、连接成功时，云台相机图标点亮。                                        \n2、与云台连接后，相机所有按键不可用。\n3、稳定器控制相机拍照或录像时，建议手动将相机的模式对应设置成拍照或录像，否则可能会出现控制失灵的情况。"
    }
]
export default data